<template lang="pug">
b-modal(:value="true" ref="changeDeliveryStateMasiveModal" hide-footer title="Cambio de estado masivo" size="lg")
  b-form#DeliveriesChangeDriverForm(@submit.stop.prevent="onSubmit")
    .ml-2.text-danger {{ errorDetail }}
    .ml-2.text-danger(v-if="notFoundIds.length && !loadingDeliveries") {{ notFoundIds.length }} Envíos no encontrados: {{notFoundIds.join(', ')}}
    b-form-group(invalid-feedback="Este campo es requerido")
      .input-title Ids de Envíos
      v-select(multiple v-model="form.ids" taggable placeholder="Selecciona los envíos")
    b-form-group
      .input-title Estado
      b-form-select.input.w-100(
        v-model="form.state"
      )
        b-form-select-option(v-for="option in stateOptions" :value="option.value") {{ option.text }}
    hr.linea
    h5 {{deliveries.length}} Envíos Seleccionados
    b-table(:items="deliveries" :fields="tableFields" responsive style="max-height: 400px; overflow-y: auto" :busy="loadingDeliveries")
      template(#head(clearCommentary))
          b-form-checkbox(v-model="selectedAllIds" @change="toggleSelectAll") Borrar comentario ({{countClearCommentary}}/{{deliveries.length}})
      template(#cell(clearCommentary)="{item}")
        b-form-checkbox(v-model="clearCommentaryObjs[item.id]")
      template(#cell(state)="{value, item}")
        DeliveryStateBadge(:state="item.state")

    .text-right
      b-button(type="submit" :disabled="loading") Guardar
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import { deliveryStatesOptions, deliveryStates } from '../../utils/deliveryUtils'
import DeliveryStateBadge from '../UI/DeliveryStateBadge.vue'
export default {
  components: {
    DeliveryStateBadge
  },
  props: {
    ids: {
      type: Array,
      default: () => []
    }
  },
  data () {
    console.log(deliveryStatesOptions)
    return {
      loadingDeliveries: false,
      deliveryStates,
      loading: false,
      errorDetail: null,
      selectedAllIds: false,
      stateOptions: deliveryStatesOptions,
      tableFields: [
        { key: 'id', label: 'Id' },
        { key: 'state', label: 'Estado' },
        { key: 'commentary', label: 'Comentario' },
        { key: 'clearCommentary', label: 'Borrar Comentario' }
      ],
      deliveries: [],
      clearCommentaryObjs: {},
      form: {
        state: null,
        ids: []
      }
    }
  },
  methods: {
    ...mapActions(['changeDeliveryStateMasive', 'getDeliveriesByIds']),
    toggleSelectAll(value) {
      this.clearCommentaryObjs = this.deliveries.reduce((acc, delivery) => {
        acc[delivery.id] = value
        return acc
      }, {})
    },
    async fetchDeliveries () {
      this.loadingDeliveries = true
      try {
        this.errorDetail = null
        const params = {
          ids: this.form.ids.toString(),
        }
        const response = await this.getDeliveriesByIds(params)
        this.deliveries = response.data
      } catch (error) {
        console.log(error)
        this.errorDetail = error?.response?.data?.detail || error?.message
      } finally {
        this.loadingDeliveries = false
      }
    },
    show (ids=[]) {
      console.log(ids)
      this.form.ids = [...ids]
      this.form.state = null
      this.deliveries = []
      this.errorDetail = null
      this.selectedAllIds = false
      this.fetchDeliveries()
      this.$refs.changeDeliveryStateMasiveModal.show()
    },
    async onSubmit () {
      this.loading = true
      this.errorDetail = null
      try {
        const ok = await this.$bvModal.msgBoxConfirm('¿Estás seguro de cambiar el estado de los envíos seleccionados?', {
          title: 'Confirmar Cambio de Estado',
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        if (!ok) return

        const response = await this.changeDeliveryStateMasive(this.data)
        if (response.status >= 200 && response.status < 300) {
          this.$root.$bvToast.toast('Envíos actualizados correctamente', {
            title: 'Éxito',
            variant: 'success',
          })
          this.$emit('done')
          this.$refs.changeDeliveryStateMasiveModal.hide()
        } else if (response.status >= 400) {
          this.$root.$bvToast.toast(response.data.message || 'Error al cambiar el estado', {
            title: 'Error',
            variant: 'danger',
          })
          console.log(response)
        }
      } catch (error) {
        console.log(error)
        this.errorDetail = error?.response?.data?.detail || error?.message
      } finally {
        this.loading = false
      }
    },
    updateclearCommentaryObjs () {
      const newResult = {}
      
      for (const delivery of this.deliveries) {
        newResult[delivery.id] = this.clearCommentaryObjs[delivery.id] || false
      }
      this.clearCommentaryObjs = newResult
    }
  },
  watch: {
    'form.ids' () {
      this.fetchDeliveries()
    },
    deliveries () {
      this.updateclearCommentaryObjs()
    }
  },
  computed: {
    selectedIds () {
      return this.form.ids.map(id => {
        let formaredId = id
        if (typeof formaredId === 'string') {
          formaredId = formaredId.trim()
        }
        const parsedId = parseInt(formaredId)
        return Number.isInteger(parsedId) ? parsedId : formaredId
      })
    },
    foundedIds () {
      return this.deliveries.map(delivery => delivery.id)
    },
    data () {
      return {
        deliveries: this.selectedIds.map(id => ({ id, clearCommentary: this.clearCommentaryObjs[id] })),
        state: this.form.state
      }
    },
    notFoundIds () {
      return this.selectedIds.filter(selectedId => !this.foundedIds.includes(selectedId))
    },
    countClearCommentary () {
      return this.deliveries.filter(delivery => this.clearCommentaryObjs[delivery.id]).length
    }
  }
}
</script>
